import { ActionReducerMap } from '@ngrx/store';
import { routerReducer } from '../router/reducer';
import { IAppState } from '../state/app.state';

export const APP_REDUCERS: ActionReducerMap<IAppState, any> = {
  router: routerReducer
};
